import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import {
  connectFunctionsEmulator,
  getFunctions,
  httpsCallable,
} from "firebase/functions";
import { connectStorageEmulator, getStorage } from "firebase/storage";

import { firebaseConfig as config } from "./config";

export const firebaseApp = initializeApp(config);

export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
export const storage = getStorage(firebaseApp);
export const functions = getFunctions(firebaseApp);

if (typeof window !== "undefined") {
  window.auth = auth;
}

if (import.meta.env.VITE_USE_EMULATOR === "true") {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", 8083);
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
  if (import.meta.env.VITE_USE_STORAGE_EMULATOR === "true") {
    connectStorageEmulator(storage, "127.0.0.1", 9199);
  }
  console.log("[firebase] Connected to local emulators");
}

//
// Callable functions -- ALL OF THESE ARE GOING -> MOVED TO PYTHON API
// NEW CODE IN /lib/apis.ts
// haven't deleted yet a s here to keep code from at least starting up

export const saveSessionNote = httpsCallable(
  functions,
  "session-saveSessionNote"
);
export const submitTranscriptionJob = httpsCallable(
  functions,
  "transcription-submitTranscriptionJob"
);
